// Shared gift promo logic for cart drawer + cart page
window.GiftPromo = (function () {
  console.log('GiftPromo', window.GiftPromoConfig);
  let ext = window.GiftPromoConfig || {};
  const CONFIG = {
    THRESHOLD: ext.threshold || 300,
    GIFT_PRODUCTS: Array.isArray(ext.giftProducts) ? ext.giftProducts : [],
    GIFT_TAG: 'yes',
    START_TIME: ext.startTime || '',
    END_TIME: ext.endTime || ''
  };

  function isPromoActive() {
    if (!CONFIG.GIFT_PRODUCTS.length) return false;
    if (!CONFIG.START_TIME || !CONFIG.END_TIME) return false;

    let now = new Date();
    let startTime = new Date(CONFIG.START_TIME);
    let endTime = new Date(CONFIG.END_TIME);
    if (Number.isNaN(startTime.getTime()) || Number.isNaN(endTime.getTime())) return false;
    if (endTime <= startTime) return false;
    if (now < startTime) return false;
    if (now > endTime) return false;
    return true;
  }

  const STUDIOFORGE_VARIANT_IDS = [52311667245423, 52174206108015, 52042575577455];
  // const GOT_VARIANT_IDS = [51648018547055, 51648018612591, 51648018940271];
  let isProcessing = false;

  function isGiftItem(item) {
    return item.properties && item.properties._isGift === CONFIG.GIFT_TAG;
  }

  function isStudioForgeItem(item) {
    return STUDIOFORGE_VARIANT_IDS.indexOf(item.variant_id) !== -1;
  }

  function disableCheckoutButtons() {
    document.querySelectorAll('button.cart__checkout').forEach(function (btn) {
      btn.disabled = true;
      btn.classList.add('btn--loading', 'disabled');
    });
  }

  function enableCheckoutButtons() {
    document.querySelectorAll('button.cart__checkout').forEach(function (btn) {
      btn.disabled = false;
      btn.classList.remove('btn--loading', 'disabled');
    });
  }

  async function checkAndManageGift(refreshCallback) {
    if (isProcessing) return false;
    isProcessing = true;

    try {
      let res = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (!res.ok) return false;
      let contentType = res.headers.get('content-type') || '';
      if (contentType.includes('text/html')) return false;
      let cart = await res.json();
      if (!cart) return false;

      let cartTotal = cart.items.reduce(function (total, item) {
        if (isGiftItem(item) || isStudioForgeItem(item)) return total;
        return total + (item.final_line_price || item.line_price || 0);
      }, 0);

      let hasGift = cart.items.some(isGiftItem);
      // let hasGOT = cart.items.some(function (item) {
      //   return GOT_VARIANT_IDS.indexOf(item.variant_id) !== -1;
      // });
      let thresholdMet = (cartTotal / 100) >= CONFIG.THRESHOLD;

      let promoActive = isPromoActive();

      if (promoActive && thresholdMet && !hasGift) {
        let added = await addGift(refreshCallback);
        if (!added && hasGift) return await removeGift(cart, refreshCallback);
        return added;
      } else if ((!thresholdMet || !promoActive) && hasGift) {
        return await removeGift(cart, refreshCallback);
      }
    } catch (e) {
      console.error('Gift promo error:', e);
    } finally {
      isProcessing = false;
    }
    return false;
  }

  async function addGift(refreshCallback) {
    try {
      console.log(isPromoActive);
      disableCheckoutButtons();

      for (let gp of CONFIG.GIFT_PRODUCTS) {
        if (!gp || !gp.handle) continue;

        let res = await fetch('/products/' + gp.handle + '.js');
        if (!res.ok) continue;
        let product = await res.json();
        if (!product || !product.variants || !product.variants.length) continue;

        let availableVariants = product.variants.filter(function (v) { return v.available; });
        if (!availableVariants.length) continue;
        let randomVariant = availableVariants[Math.floor(Math.random() * availableVariants.length)];

        let addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: randomVariant.id,
              quantity: 1,
              properties: { _isGift: CONFIG.GIFT_TAG }
            }]
          })
        });
        if (!addRes.ok) continue;

        if (refreshCallback) await refreshCallback();
        return true;
      }

      return false;
    } catch (e) {
      console.error('Gift promo add error:', e);
      return false;
    }
  }

  async function removeGift(cart, refreshCallback) {
    try {
      let giftItem = cart.items.find(isGiftItem);
      if (!giftItem) return false;

      disableCheckoutButtons();
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key || giftItem.variant_id, quantity: 0 })
      });

      if (refreshCallback) await refreshCallback();
      return true;
    } catch (e) {
      console.error('Gift promo remove error:', e);
      return false;
    }
  }

  return {
    CONFIG: CONFIG,
    disableCheckout: disableCheckoutButtons,
    enableCheckout: enableCheckoutButtons,
    checkAndManageGift: checkAndManageGift
  };
})();
